import { useEffect } from "react";

type PageMeta = {
  title: string;
  description?: string;
  robots?: string;
};

export function usePageMeta({ title, description, robots }: PageMeta) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, true);
    }
    setMeta("og:title", title, true);
    if (robots) setMeta("robots", robots);
  }, [title, description, robots]);
}
